import { SITE_URL } from "./useSEO";

export { SITE_URL };

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const aboutPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "AboutPage",
  url: `${SITE_URL}/about`,
  name: "About Oguzhan Ozcelik",
  description:
    "Background, skills and tools of Oguzhan Ozcelik — full-stack developer & Shopify expert.",
  mainEntity: { "@id": `${SITE_URL}/#person` },
});

export const collectionPageSchema = ({ name, description, path, items }) => ({
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  url: `${SITE_URL}${path}`,
  name,
  description,
  hasPart: items.map((it) => ({
    "@type": "CreativeWork",
    name: it.name,
    url: it.url,
    image: it.image,
  })),
});

export const profilePageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfilePage",
  url: `${SITE_URL}/resume`,
  name: "Oguzhan Ozcelik — Resume",
  mainEntity: { "@id": `${SITE_URL}/#person` },
});
